export type IdentityFn<Ctx extends Record<string, unknown>> = (
  arg0: Ctx
) => Ctx;

export default function flow<Ctx extends Record<string, unknown>>(
  fns: IdentityFn<Ctx>[]
): IdentityFn<Ctx> {
  return (initialCtx) => fns.reduce((ctx, fn) => fn(ctx), initialCtx);
}
